import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_OnProvideInfoContextChange = new ThunderDispatcher('__onProvideInfoContextChange');
export const dispatch_OnProvideInfoContextUpdate = new ThunderDispatcher('__onProvideInfoContextUpdate');
export const dispatch_OnProvideInfoExplain = new ThunderDispatcher('__onProvideInfoExplain');
//# sourceMappingURL=dispatchers.js.map